import { List, Map } from 'immutable';
import { SUCCESS_FETCH_PREMATCH_MENU, FETCH_PREMATCH_MENU, CLEAR_LINE } from '../../actions/lines';
var initialState = Map({
    sports: Map(),
    menuFetching: false
});
export default function sportsReducer(sports, action) {
    if (sportsReducer === undefined) {
        return initialState;
    }
    switch (action.type) {
        case FETCH_PREMATCH_MENU:
            return sports.update('menuFetching', function () { return true; });
        case SUCCESS_FETCH_PREMATCH_MENU:
            sports = sports.update('menuFetching', function () { return false; });
            return sports.update('sports', function () { return initMenu(new Map(), action.data); });
        case CLEAR_LINE:
            return initialState;
    }
    return sports;
}
function initMenu(sports, data) {
    if (data === undefined) {
        return sports;
    }
    if (data.sports !== undefined) {
        sports = addMenuSports(sports, data.sports.add);
    }
    if (data.leagues !== undefined) {
        sports = addSportLeagues(sports, data.leagues.add);
    }
    return sports;
}
function addMenuSports(sports, addSports) {
    if (addSports === undefined) {
        return sports;
    }
    sports = sports.withMutations(function (s) {
        for (var i = 0; i < addSports.length; i++) {
            var sport = new Map(addSports[i]);
            sport = sport.set('leagues', new List());
            s.set(sport.get('id'), sport);
        }
    });
    return sports;
}
function addSportLeagues(sports, addLeagues) {
    if (addLeagues === undefined) {
        return sports;
    }
    for (var i = 0; i < addLeagues.length; i++) {
        var sportId = addLeagues[i].sportId;
        var leagueId = addLeagues[i].id;
        (function (sportId, leagueId) {
            sports = sports.updateIn([sportId, 'leagues'], function (l) { return l.push(leagueId); });
        })(sportId, leagueId);
    }
    return sports;
}



// WEBPACK FOOTER //
// ./src/reducers/menu/linesMenuReducer.js